import React from 'react';
import { useFela } from 'react-fela';

const rules = ({ theme }) => ({
  color: theme.color.light,
  display: 'flex',
  height: '14px',
  justifyContent: 'center',
  position: 'relative',
  textAlign: 'center',
  width: '100%',
});

export const ProgressBarWrapper = (props) => {
  const { css } = useFela();

  return (
    <div className={css(rules)} {...props} />
  );
};

export default React.memo(ProgressBarWrapper);
